/* eslint-disable class-methods-use-this */
import React from 'react';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';

import { colors, fontWeights, lineHeights } from 'style/config';
import { Box, Icon } from 'components/ui';
import Dropdown from 'components/Dropdown/Dropdown';
import StoresContent from 'components/Header/StoresContent/StoresContent';
import PreferredStore from 'components/PreferredStore/PreferredStore';
import PreferredStoreAndZipCode from 'components/ShopYourStore/PreferredStoreAndZipCode';
import StoreAndDeliveryFlyout from 'components/ShopYourStore/StoreAndDeliveryFlyout';
import StoreAndDeliverySLA from 'components/ShopYourStore/StoreAndDeliverySLA';
import { NEW_BADGE } from 'constants/ShopYourStore';
import localeUtils from 'utils/LanguageLocale';
import helpersUtils from 'utils/Helpers';
import HeaderEN from 'components/Header/locales/Header_en_US';
import HeaderFR from 'components/Header/locales/Header_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;
const getText = getLocalisedDataFromResource(HeaderEN, HeaderFR);
const { deferTaskExecution } = helpersUtils;

class StoresDrop extends BaseClass {
    state = {
        isOpen: false
    };

    triggerDropdown = (_, isOpen) => {
        deferTaskExecution(() => {
            this.setState({ isOpen });
        });
    };

    render() {
        const { isOpen } = this.state;
        const { isShopYourStoreEnabled, showNewBadge, isMegaNavOffersChallenger, showServicesAndEventsInFlyout } = this.props;
        const translationKey = isShopYourStoreEnabled ? 'shopStoreAndDelivery' : 'storesAndServices';
        const Title = getText(translationKey);
        const Subtitle = isShopYourStoreEnabled ? PreferredStoreAndZipCode : PreferredStore;
        const isFRCanada = localeUtils.isFRCanada();

        return (
            <Dropdown
                id='stores_drop'
                hasMaxHeight={true}
                onTrigger={this.triggerDropdown}
            >
                <Dropdown.Trigger
                    display='flex'
                    alignItems='center'
                    paddingX={4}
                    lineHeight='tight'
                    height='100%'
                    data-at={Sephora.debug.dataAt('stores_and_services_header')}
                >
                    <Box
                        is='span'
                        css={styles.badgeAndIconWrapper}
                    >
                        <Icon
                            name={isOpen ? 'storeActive' : 'store'}
                            size={24}
                            marginTop='-.125em'
                            style={{ opacity: !isOpen ? 0.6 : null }}
                        />
                        {showNewBadge && (
                            <Box
                                is='span'
                                css={styles.badge}
                            >
                                {isFRCanada ? NEW_BADGE.FR : NEW_BADGE.EN}
                            </Box>
                        )}
                    </Box>
                    <Box
                        is='span'
                        marginLeft={3}
                    >
                        <Box
                            is='span'
                            css={isMegaNavOffersChallenger && styles.stackedLabel}
                        >
                            {Title}
                        </Box>
                        <Subtitle
                            hasSephora={false}
                            maxStoreNameLength={isMegaNavOffersChallenger ? 14 : undefined}
                            maxWidth={['28ch', null, null, '46ch']}
                            display='block'
                            fontSize='xs'
                            paddingBottom={1}
                            marginBottom={-1}
                            color={isOpen ? 'inherit' : 'gray'}
                            css={isOpen && styles.triggerLabelActive}
                        />
                    </Box>
                    {isShopYourStoreEnabled && <StoreAndDeliverySLA isFlyoutOpen={isOpen} />}
                </Dropdown.Trigger>
                <Dropdown.Menu
                    width={this.props.dropWidth}
                    align='center'
                    data-at={Sephora.debug.dataAt('stores_and_services_dropdown')}
                    paddingY={isShopYourStoreEnabled ? 4 : 5}
                >
                    {isShopYourStoreEnabled ? (
                        <StoreAndDeliveryFlyout
                            showServicesAndEvents={showServicesAndEventsInFlyout}
                            servicesAndEventsItems={this.props.items}
                        />
                    ) : (
                        <StoresContent items={this.props.items} />
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

const styles = {
    triggerLabelActive: {
        boxShadow: `0 2px 0 0 ${colors.black}`
    },
    stackedLabel: {
        fontWeight: fontWeights.bold
    },
    badgeAndIconWrapper: {
        position: 'relative'
    },
    badge: {
        position: 'absolute',
        right: '30%',
        top: '-26%',
        padding: '2px',
        color: colors.white,
        backgroundColor: colors.black,
        border: '1px solid',
        borderColor: colors.white,
        borderRadius: '4px',
        fontSize: '8px',
        fontWeight: fontWeights.bold,
        lineHeight: lineHeights.none,
        textTransform: 'uppercase'
    }
};

export default wrapComponent(StoresDrop, 'StoresDrop');
